import { render, staticRenderFns } from "./TabletNiche.vue?vue&type=template&id=6d4b31cd&scoped=true"
import script from "./TabletNiche.vue?vue&type=script&lang=js"
export * from "./TabletNiche.vue?vue&type=script&lang=js"
import style0 from "./TabletNiche.vue?vue&type=style&index=0&id=6d4b31cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4b31cd",
  null
  
)

export default component.exports